/**
 * Единое построение чистого share-URL карточки товара (B-222, COORD_Ответ3).
 * Один хелпер на decors/handles/furniture — замена «длинная → короткая ссылка»
 * правится в ОДНОМ месте, а не в трёх card-view'ах.
 *
 * Замена реализована (ADR-0095 Фаза C): при наличии `shortId` (A2-контракт,
 * `<prefix><share_hash>`, уже URL-safe base62) возвращаем КОРОТКУЮ ссылку
 * `${origin}/s/${shortId}` (резолв-эндпоинт `/s/<id>` отдаёт OG + редирект на
 * карточку). `shortId` НЕ прогоняется через `encodeURIComponent` — он url-safe.
 *
 * Нет `shortId` (старые данные / непросеянный товар) → ФОЛБЭК на длинный путь,
 * БАЙТ-ИДЕНТИЧНЫЙ прежним локальным `cleanCardUrl`/`cardUrl` (P-001 энкодинг
 * globalId не меняется) — sharing никогда не падает:
 *   decors    → `${origin}/decors/${enc(kind)}/${enc(globalId)}`
 *   handles   → `${origin}/handles/${enc(kind)}/${enc(globalId)}`
 *   furniture → `${origin}/furniture/${enc(globalId)}`   (БЕЗ kind)
 *
 * `origin` берётся из `window.location.origin` (на сервере/в тестах без window — `''`).
 * Меняем ТОЛЬКО построение URL; текст сообщения (forwardTextNoUrl/forwardMessage) —
 * не трогаем. Типобезопасно через overloads (discriminated по `domain`), без `any`.
 */

const getOrigin = (): string => (typeof window !== 'undefined' ? window.location.origin : '');
const enc = encodeURIComponent;

export function buildCardShareUrl(
  domain: 'decors',
  params: { kind: string; globalId: string; shortId?: string },
): string;
export function buildCardShareUrl(
  domain: 'handles',
  params: { kind: string; globalId: string; shortId?: string },
): string;
export function buildCardShareUrl(
  domain: 'furniture',
  params: { globalId: string; shortId?: string },
): string;
export function buildCardShareUrl(
  domain: 'decors' | 'handles' | 'furniture',
  params:
    | { kind: string; globalId: string; shortId?: string }
    | { globalId: string; shortId?: string },
): string {
  const base = getOrigin();
  // Короткая ссылка при наличии shortId (url-safe base62 — без encodeURIComponent).
  // Пустой shortId ('') falsy → фолбэк на длинный путь.
  if (params.shortId) {
    return `${base}/s/${params.shortId}`;
  }
  if (domain === 'furniture') {
    return `${base}/furniture/${enc(params.globalId)}`;
  }
  // decors | handles — путь с kind (overloads гарантируют наличие `kind`).
  const kind = 'kind' in params ? params.kind : '';
  return `${base}/${domain}/${enc(kind)}/${enc(params.globalId)}`;
}
